// FRE-290: thin client around /api/v1/me/onboarding. Extended in FRE-294 with
// the Generic self-mark helper; mcpClientsSeen remains server-write-only (FRE-295).

import { ApiError, UnauthorizedError, apiGet, apiPatch } from "@/lib/api.ts";

export type OnboardingState = {
  dotDismissedAt: string | null;
  mcpClientsSeen: Record<string, string>;
  manualClientsMarked: Record<string, string>;
  updatedAt: string;
};

export async function fetchOnboarding(): Promise<OnboardingState | null> {
  try {
    return await apiGet<OnboardingState>("/api/v1/me/onboarding");
  } catch (err) {
    // Decorative state — never block rendering on this. Pre-auth callers
    // (logged-out users hitting a public route) get a 401 here, which is fine
    // — the drawer's UI is gated on the presence of a session anyway.
    if (err instanceof UnauthorizedError) return null;
    if (err instanceof ApiError) return null;
    throw err;
  }
}

export async function dismissOnboardingDot(): Promise<OnboardingState> {
  return apiPatch<OnboardingState>("/api/v1/me/onboarding", {
    dotDismissedAt: new Date().toISOString(),
  });
}

// FRE-294: "I've set this up" self-mark for the Generic MCP client bucket.
// The worker enforces that no other bucket key is accepted via this path —
// the 7 known clients are written from the MCP route on first authenticated
// call (FRE-295).
export async function markGenericClient(): Promise<OnboardingState> {
  return apiPatch<OnboardingState>("/api/v1/me/onboarding", {
    manualClientsMarked: { generic: new Date().toISOString() },
  });
}
